export const beltCarcassType = [
    {
        text: 'EP',
        value: 'EP',
    },
    {
        text: 'NN',
        value: 'NN',
    },
    {
        text: 'ST',
        value: 'ST',
    },
];

// Length Factor 시작
export const lengthFactors = [
    { threshold: 80, factor: 1.92 },
    { threshold: 100, factor: 1.78 },
    { threshold: 150, factor: 1.58 },
    { threshold: 200, factor: 1.45 },
    { threshold: 200, factor: 1.45 },
    { threshold: 300, factor: 1.31 },
    { threshold: 400, factor: 1.25 },
    { threshold: 500, factor: 1.2 },
    { threshold: 600, factor: 1.17 },
    { threshold: 700, factor: 1.14 },
    { threshold: 800, factor: 1.12 },
    { threshold: 900, factor: 1.1 },
    { threshold: 1000, factor: 1.09 },
    { threshold: 1500, factor: 1.06 },
    { threshold: 2000, factor: 1.05 },
];

const linearInterpolate = (x, x0, y0, x1, y1) => {
    return y0 + ((x - x0) * (y1 - y0)) / (x1 - x0);
};

export const getLengthCoefficient = (distance) => {
    if (distance < lengthFactors[0].threshold) {
        return 'N/A'; // 최소값보다 작은 경우 최소값 반환
    }

    for (let i = 0; i < lengthFactors.length - 1; i++) {
        if (distance === lengthFactors[i].threshold) {
            return lengthFactors[i].factor;
        } else if (distance < lengthFactors[i + 1].threshold) {
            return linearInterpolate(
                distance,
                lengthFactors[i].threshold,
                lengthFactors[i].factor,
                lengthFactors[i + 1].threshold,
                lengthFactors[i + 1].factor,
            );
        }
    }

    return lengthFactors[lengthFactors.length - 1].factor; // 최대값보다 큰 경우 최대값 반환
};
// Length Factor 끝.

// export const beltWidthRating = [400, 500, 650, 750, 800, 900, 1000, 1050, 1200, 1400, 1600, 1800, 2000, 2200, 2400, 2600];
export const beltWidthRating = [
    { text: 'BW400', value: '400' },
    { text: 'BW500', value: '500' },
    { text: 'BW650', value: '650' },
    { text: 'BW750', value: '750' },
    { text: 'BW800', value: '800' },
    { text: 'BW900', value: '900' },
    { text: 'BW1000', value: '1000' },
    { text: 'BW1050', value: '1050' },
    { text: 'BW1200', value: '1200' },
    { text: 'BW1400', value: '1400' },
    { text: 'BW1600', value: '1600' },
    { text: 'BW1800', value: '1800' },
    { text: 'BW2000', value: '2000' },
    { text: 'BW2200', value: '2200' },
    { text: 'BW2400', value: '2400' },
    { text: 'BW2600', value: '2600' },
];

export const formatSafeValue = (value) => {
    return isNaN(value) || value === '0' || !isFinite(value) ? '' : Number(value);
};

export const motorRanking = [
    { text: '2.2kW', value: 2.2 },
    { text: '3.7kW', value: 3.7 },
    { text: '5.5kW', value: 5.5 },
    { text: '7.5kW', value: 7.5 },
    { text: '11kW', value: 11 },
    { text: '15kW', value: 15 },
    { text: '18.5kW', value: 18.5 },
    { text: '22kW', value: 22 },
    { text: '30kW', value: 30 },
    { text: '37kW', value: 37 },
    { text: '45kW', value: 45 },
    { text: '55kW', value: 55 },
    { text: '75kW', value: 75 },
    { text: '90kW', value: 90 },
    { text: '110kW', value: 110 },
    { text: '132kW', value: 132 },
    { text: '150kW', value: 150 },
    { text: '160kW', value: 160 },
    { text: '185kW', value: 185 },
    { text: '200kW', value: 200 },
    { text: '225kW', value: 225 },
    { text: '250kW', value: 250 },
    { text: '260kW', value: 260 },
    { text: '280kW', value: 280 },
    { text: '300kW', value: 300 },
    { text: '315kW', value: 315 },
    { text: '335kW', value: 335 },
    { text: '355kW', value: 355 },
    { text: '375kW', value: 375 },

];

export const selectMotor = (value) => {
    const inputPower = parseFloat(value);
    if (isNaN(value)) {
        return null;
    }
    for (const motor of motorRanking) {
        const motorPower = parseFloat(motor.value);
        if (motorPower > inputPower) {
            return motor.value;
        }
    }
    return null;
}


const widthDataLibrary = [  // MMM 자료임.
    { beltWidth: 400, rotatingMassCarry: 9.9, rotatingMassReturn: 7.8, massBelt: 4.5, beltThick: 9.0 },
    { beltWidth: 500, rotatingMassCarry: 11.4, rotatingMassReturn: 9.3, massBelt: 7.5, beltThick: 12.0 },
    { beltWidth: 650, rotatingMassCarry: 12.6, rotatingMassReturn: 10.7, massBelt: 10.0, beltThick: 12.0 },
    { beltWidth: 750, rotatingMassCarry: 20.4, rotatingMassReturn: 17.8, massBelt: 13.0, beltThick: 13.0 },
    { beltWidth: 800, rotatingMassCarry: 20.4, rotatingMassReturn: 17.8, massBelt: 14.0, beltThick: 13.0 },
    { beltWidth: 900, rotatingMassCarry: 23.7, rotatingMassReturn: 20.6, massBelt: 15.5, beltThick: 13.0 },
    { beltWidth: 1000, rotatingMassCarry: 21.3, rotatingMassReturn: 18.9, massBelt: 20.0, beltThick: 16.0 },
    { beltWidth: 1050, rotatingMassCarry: 21.3, rotatingMassReturn: 18.9, massBelt: 23.0, beltThick: 17.0 },
    { beltWidth: 1200, rotatingMassCarry: 23.6, rotatingMassReturn: 21.1, massBelt: 26.0, beltThick: 17.0 },
    { beltWidth: 1400, rotatingMassCarry: 36.6, rotatingMassReturn: 32.6, massBelt: 33.0, beltThick: 18.0 },
    { beltWidth: 1600, rotatingMassCarry: 41.4, rotatingMassReturn: 36.6, massBelt: 38.0, beltThick: 18.0 },
    { beltWidth: 1800, rotatingMassCarry: 47.4, rotatingMassReturn: 42.5, massBelt: 46.0, beltThick: 20.0 },
    { beltWidth: 2000, rotatingMassCarry: 52.2, rotatingMassReturn: 46.5, massBelt: 51.0, beltThick: 20.0 },
    { beltWidth: 2200, rotatingMassCarry: 57.0, rotatingMassReturn: 54.1, massBelt: 56.0, beltThick: 20.0 },
    { beltWidth: 2400, rotatingMassCarry: 62.0, rotatingMassReturn: 61.0, massBelt: 61.0, beltThick: 20.0 },
    { beltWidth: 2600, rotatingMassCarry: 77.0, rotatingMassReturn: 68.0, massBelt: 66.0, beltThick: 20.0 },
];

export const getWidthRelatedValue = (beltWidth, propertyName) => {
    const item = widthDataLibrary.find(
        (obj) => obj.beltWidth === parseInt(beltWidth),
    );
    if (!item) {
        return undefined;
    }
    return item[propertyName];
};

export const getTentativeTension = (f, Q, L, v, g, qRO, qRU, qB, H) => {
    // const f = parseFloat(input.artificialFrictionCoeff);
    // const Q = parseFloat(input.capacity);
    // const L = parseFloat(input.length);
    // const v = parseFloat(input.beltSpeed);
    // const g = 9.806;
    // const qRO = output.massCarryIdler;
    // const qRU = output.massReturnIdler;
    // const qB = output.massBelt;
    // const H = parseFloat(input.height);

    const P1 = (0.06 * f * (qRO + qRU + 2 * qB) * v * (L + 66)) / 367;
    const P2 = (f * Q * (L + 66)) / 367;
    const P3 = (H * Q) / 367;
    const P = P1 + P2 + P3;
    const resistance = P * 1000 / v;

    const averageTensionInBelt = Math.ceil(resistance * 1.0); // 보통 T1이 1.71배 정도임. 초기 계산용임을 감안하여 다소 크게 추정하였음.
    const averageResultantForce = Math.ceil(resistance * 1.0); // 90도 부터 200도 등 다양하게 있지만 평균값으로 사용하기 위해 러프하게 추정함.

    return [averageTensionInBelt, averageResultantForce];
};
